<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
            <v-container>
                <v-row>
                    <v-card elevation="12" class="border" :height="`${98.5}%`"
                        style="position: absolute; width: 98%; margin-top: 1%; margin-left: 1%; margin-right: 1%; padding-bottom: 5%; border-radius: 9px;">
                        <p
                            style="margin-top: 15%; font-family: Lato; text-transform: unset !important; font-style: normal; color: #3F616C; font-size: 20px; font-weight: 300;">
                            Bienvenido </p>
                        <img src="./../assets/images/Logo_calper_pequeño.png"
                            style="position: absolute; bottom: 50%; left: 20%;" />
                        <a href="https://www.endoscopiahuc.info/" style="position: absolute; bottom: 45%; width: 100%; left: 0%; font-family: Lato; font-style: normal; color: #3F616C; font-size: 18px; font-weight: 300;">Más información</a>
                        <div style="display: flex; align-items: flex-end; flex: 1 1 auto; position: absolute; bottom: 25%; width: 100%">
                            <v-btn elevation="12" v-on:click="onContinueClick()"
                                style="margin-left: auto; margin-right: auto; width: 180px; height: 50px; border: 1px solid #E9F6FB;
                                font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;"
                            >
                                <b>Continuar</b>
                            </v-btn>
                        </div>
                        <img src="./../assets/images/logo_FIISC_pequeño.png"
                            style="position: absolute; bottom: 5%; left: 30%;" width="134px" height="51px" />
                    </v-card>
                </v-row>
            </v-container>
    </v-main>
</template>

<script>
import axios from "axios";
import { preference } from "vue-preferences";
import { nextScreen } from '../router/utils.js';
const api = require('../../config/conf.env');

export default {
    name: 'WelcomeInfo',
    methods: {
        async onContinueClick() {
            nextScreen(this.$router, '/lastdeposited');
        },
    },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/WelcomeInfo.vue